import { Button, DatePicker, Flex, Image, Input, TableProps } from "antd";
import dayjs, { Dayjs } from "dayjs";
import DownloadIcon from "../../../../../../assets/icons/DownloadIcon";
import SearchIcon from "../../../../../../assets/icons/SearchIcon";
import UploadIcon from "../../../../../../assets/icons/UploadIcon";
import placeholder from "../../../../../../assets/images/avatar.svg";
import CustomTable from "../../../../../../components/ui/CustomTable";
import { dbDateFormat } from "../../../../../../constants/constants";
import { AllKPIAchievementParams } from "../../../../../../features/organization/contractual/JobDetails/jobDetails.type";
import { useGetKPIAchievementQuery } from "../../../../../../features/organization/contractual/JobDetails/jobDetailsApi";
import useModal from "../../../../../../hooks/useModal";
import useTable from "../../../../../../hooks/useTable";
import { formatDate } from "../../../../../../lib/time";
import { countParPageSerialNumber } from "../../../../../../utils/number";
import { valueOrNa } from "../../../../../../utils/string";
import { addKeyInArray } from "../../../../../../utils/utils";
import CalanderIcon from "../../../../survey/templates/_icons/CalanderIcon";
import DownloadTemplate from "./DownloadTemplate";
import ImportKPIPerformance from "./ImportKPIPerformance";
const { RangePicker } = DatePicker;
const KPIPerformance = () => {
  const { open, handleOpen, handleClose } = useModal<
    unknown,
    "DOWNLOAD" | "IMPORT"
  >();

  const {
    page,
    limit,
    filter,
    keyword,
    handleLimit,
    handleFilter,
    handleSearch,
    handlePagination,
  } = useTable<AllKPIAchievementParams>();

  const { data, isLoading, isFetching } = useGetKPIAchievementQuery({
    params: { ...filter, search: keyword },
  });

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Bondhu Name",
      dataIndex: "user_name",
      render: (val) => (
        <Flex align="center" gap={6}>
          <Image
            width={38}
            height={38}
            preview={false}
            src={placeholder}
            className="rounded-full"
          />
          <span>{val}</span>
        </Flex>
      ),
    },
    {
      align: "center",
      title: "Bondhu ID",
      dataIndex: "employee_id",
      render: (val) => valueOrNa(val),
    },
    {
      align: "center",
      title: "KPI Group",
      dataIndex: "kpi_group_name",
      render: (val) => valueOrNa(val),
    },
    {
      align: "center",
      title: "Dates Range",
      render: (record) => (
        <span>
          {formatDate(record?.period_from, "DD MMM")} to{" "}
          {formatDate(record?.period_to)}
        </span>
      ),
    },
    {
      align: "center",
      title: "Total Achievement",
      dataIndex: "total_achievement",
      render: (val) => valueOrNa(val),
    },
  ];

  return (
    <>
      <CustomTable
        loading={isLoading || isFetching}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data.total}
        dataSource={addKeyInArray(data?.data.summaries)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
            />

            <RangePicker
              style={{ width: 245 }}
              separator="-"
              className="w-full input-bordered"
              format={"DD/MM/YYYY"}
              suffixIcon={<CalanderIcon />}
              placeholder={["dd/mm/yyyy", "dd/mm/yyyy"]}
              onChange={(dates: (Dayjs | null)[] | null) => {
                const [start, end] = dates || [];

                // Call filter only if both dates are selected
                if (start && end) {
                  handleFilter(
                    "period_from",
                    dayjs(start).format(dbDateFormat),
                  );
                  handleFilter("period_to", dayjs(end).format(dbDateFormat));
                } else {
                  // Clear filters if user clears dates
                  handleFilter("period_from", undefined);
                  handleFilter("period_to", undefined);
                }
              }}
            />

            <Button
              onClick={() => handleOpen({ type: "DOWNLOAD" })}
              className="yellow-button"
            >
              <DownloadIcon /> Download Template
            </Button>

            <Button
              onClick={() => handleOpen({ type: "IMPORT" })}
              className="import-button"
            >
              <UploadIcon /> Import
            </Button>
          </>
        }
      />

      <DownloadTemplate
        open={open.open && open.type === "DOWNLOAD"}
        handleClose={handleClose}
      />

      <ImportKPIPerformance
        open={open.open && open.type === "IMPORT"}
        handleClose={handleClose}
      />
    </>
  );
};

export default KPIPerformance;
